<div class="poiWidget-container" #poiWidget>
                <div *ngIf="isLoaded"  class="toggle toggle-right" #toggleContainer>
                  <div class="toggle-container">
                    <label>Lifestyle</label>
                    <app-switch [inputId]="'localLogicSwitch'" [checked]="showPOI" (checkedChange)="toggle()"></app-switch>
                  </div>
                </div>
                <div class="poiWidget" id="poiWidget" ><div>
             </div>
        